<template>
    <div class="full-height">
      <q-card-section class="q-py-xs">
          <div class="report-title">
            {{name}}
          </div>
      </q-card-section>
      <crud-layout
        ref="crudLayout"
        :name="name"
        :interface="nmInterface"
        :id="id"
        :page="page"
      />
    <JtDocsViewer
      :src="fileSrc"
      :title="reportTitle"
      pdf
      ref="reportModal"
      v-on:hide="() => {showReport = false}"
    />
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDocs } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'

const { JtDocsViewer } = JtDocs
const CrudLayout = JtCrud.CrudLayout

  @Component({
    name: 'Transshipment',
    components: { CrudLayout, JtDocsViewer: JtDocs.JtDocsViewer },
    props: {
      id: String,
      interface: String,
      name: String
    }
  })
class Transshipment extends Vue {
    showReport = false;
    reportTitle = null;
    fileSrc = null;

    get nmInterface () {
      return this.interface
    }

    async actionButtonReport ({ button, params }) {
      const reportTitle = 'Rel de tickets associados pesagem transbordo'
      const { nmArquivo } = await this.$jt.repository.resolveLogic(
        'transshipmentWeighingTicketReport.transshipmentWeighingTicketReport',
        {
          batchResidue: params.id,
          totalNetWeight: params.netWeight,
          batchResidueTrip: params.batchResidueTripId,
          cdRelatorio: 'transshipmentWeighingTicketReport',
          relFormaGeracao: 1,
          relFormatoRelatorio: 3
        }
      )
      const format = 'xls'
      const result = await repository.downloadFile(nmArquivo, format, '', 'application/' + format)
      this.fileSrc = URL.createObjectURL(result)
      this.reportTitle = button.label

      this.$nextTick(() => {
        this.__downloadFile(this.fileSrc, reportTitle, '.xls')
      })
      this.modalData.show = false
    }

    mounted () {
      try {
        this.$refs.crudLayout.onButton('btReport', this.actionButtonReport)
      } catch (error) {
        console.error(error)
      }
    }

    __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
      const link = document.createElement('a')
      link.style = 'display: none'
      link.download = `${fileName}${extension}`
      link.href = fileSrc
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
export default Transshipment
</script>
  <style lang="stylus" scoped>
    report-title {
      font-weight: 500;
      font-size: 1.3em;
      margin-top: 5px;
      border-bottom: 1px solid #e0e0e0;
    }
 </style>
